import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import Helmet from "react-helmet";

export default function AlertDialog(props) {

  const handleContinue = () => {
    props.continue && props.continue();
    if(props.checkBeforeContinue) {
      props.checkBeforeContinue()
        .then((result) => {
          result && props.close();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    } else {
      props.close();
    }
  };

  return (
    <div>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <Dialog
        open={props.open}
        onClose={props.disableCancel ? handleContinue : props.close}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"

      >
        <DialogTitle style={{minWidth: '200px', ...props.titleStyle || null}} id="alert-dialog-title">{props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText
            component="div"
            id="alert-dialog-description"
            sx={{
              color: 'text.primary',
              overflowY: props.noScrollBody ? 'hidden' : 'auto',
              overflowX: props.noScrollBody ? 'hidden' : 'auto',
            }}
          >
            {props.body}
          </DialogContentText>
        </DialogContent>
        {props.wideImage && props.wideImage }
        <DialogActions>
          {!props.disableCancel &&  <Button onClick={props.close} color="primary">
            Cancel
          </Button>}
          {!props.hideContinue && <Button onClick={handleContinue} disabled={props.continueDisabled} color="primary" autoFocus>
            {props.rightButtonText || 'Continue'}
          </Button>}
        </DialogActions>
      </Dialog>
    </div>
  );
}

AlertDialog.propTypes = {
  open: PropTypes.any.isRequired,
  close: PropTypes.any.isRequired,
  continue: PropTypes.any,
  checkBeforeContinue: PropTypes.any,
  title: PropTypes.any,
  titleStyle: PropTypes.object,
  disableCancel: PropTypes.bool,
  hideContinue: PropTypes.bool,
  continueDisabled: PropTypes.bool,
  body: PropTypes.any.isRequired,
  rightButtonText: PropTypes.string,
  wideImage: PropTypes.any,
};